<template>
	<md-toolbar md-elevation="0" class="md-transparent">
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start" style="justify-content:space-between">
				<h3 v-if="$store.state.authentication.mode == 'normal'" class="md-title">{{$store.state.authentication.name}}</h3>
				<!-- <p style="margin-left: 100px">
					ម៉ាស៊ីនព្រីន:
					<span style="color:red" v-if="!printer"><a href="https://localhost:8084" target="_blank">មិនដំណើរការ</a></span>
					<span style="color:green" v-if="printer">ដំណើរការ</span>
				</p> -->
			</div>
			<div class="md-toolbar-section-end">
				
				<md-list>
					<md-list-item to="/">
						<i class="material-icons">home</i>
					</md-list-item>
					
					<md-list-item to="/driver_map" v-if="allow_user('sa') && $store.state.authentication.mode == 'normal'">
						<i class="material-icons">person_pin_circle</i>
					</md-list-item>

					<md-list-item to="/driver_packages" v-if="$store.state.authentication.mode == 'normal'" @click="driverMode()">
						<i class="material-icons">delivery_dining</i>
					</md-list-item>

					<md-list-item to="/scanner" v-if="allow_user('sa|ad|da') && $store.state.authentication.mode == 'normal'" @click="scannerMode()">
						<i class="material-icons">qr_code_scanner</i>
					</md-list-item>
					<md-list-item to="/" @click="logout()">
						<i class="material-icons">logout</i>
					</md-list-item>
				</md-list>

				<md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>
				<!-- <md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>

				<md-list>
					<md-list-item to="/">
						<i class="material-icons">home</i>
						<p class="hidden-lg hidden-md">Dashboard</p>
					</md-list-item>
					
					<md-list-item to="/driver_map" v-if="allow_user('sa') && $store.state.authentication.mode == 'normal'">
						<i class="material-icons">person_pin_circle</i>
						<p class="hidden-lg hidden-md">Map</p>
					</md-list-item>

					<md-list-item to="/driver_packages" v-if="$store.state.authentication.mode == 'normal'" @click="driverMode()">
						<i class="material-icons">delivery_dining</i>
						<p class="hidden-lg hidden-md">Driver Package</p>
					</md-list-item>

					<md-list-item to="/scanner" v-if="allow_user('sa|ad|da') && $store.state.authentication.mode == 'normal'" @click="scannerMode()">
						<i class="material-icons">qr_code_scanner</i>
						<p class="hidden-lg hidden-md">Driver Package</p>
					</md-list-item>
					<md-list-item to="/" @click="logout()">
						<i class="material-icons">logout</i>
						<p class="hidden-lg hidden-md">Dashboard</p>
					</md-list-item>
				</md-list> -->

				<!-- <div class="md-collapse">
					<md-list>
						<md-list-item to="/">
							<i class="material-icons">home</i>
						</md-list-item>
						
						<md-list-item to="/driver_map" v-if="allow_user('sa') && $store.state.authentication.mode == 'normal'">
							<i class="material-icons">person_pin_circle</i>
						</md-list-item>

						<md-list-item to="/driver_packages" v-if="$store.state.authentication.mode == 'normal'" @click="driverMode()">
							<i class="material-icons">delivery_dining</i>
						</md-list-item>

						<md-list-item to="/scanner" v-if="allow_user('sa|ad|da') && $store.state.authentication.mode == 'normal'" @click="scannerMode()">
							<i class="material-icons">qr_code_scanner</i>
						</md-list-item>
						<md-list-item to="/" @click="logout()">
							<i class="material-icons">logout</i>
						</md-list-item>
					</md-list>
				</div> -->
						<!-- <md-list-item to="/" class="dropdown" v-if="allow_user('sa|ad|da|sl') && $store.state.authentication.mode != 'driver'">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown">
									<i class="material-icons">person</i>
								</a>
								<ul class="dropdown-menu dropdown-menu-right">
									<li><a @click="driverMode()">បង្ហាញផ្ទាំងសម្រាប់អ្នកដឹក</a></li>
									<li><a @click="logout()">ចាកចេញ</a></li>
								</ul>
							</drop-down>
						</md-list-item>

						<md-list-item to="/new_package" class="dropdown" v-if="allow_user('ca') && $store.state.authentication.mode != 'driver'">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown">
									<i class="material-icons">person</i>
								</a>
								<ul class="dropdown-menu dropdown-menu-right">
									<li><a @click="driverMode()">បង្ហាញផ្ទាំងសម្រាប់អ្នកដឹក</a></li>
									<li><a @click="logout()">ចាកចេញ</a></li>
								</ul>
							</drop-down>
						</md-list-item>

						<md-list-item to="/driver_packages" class="dropdown" v-if="$store.state.authentication.mode != 'normal'">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown">
									<i class="material-icons">person</i>
								</a>
							</drop-down>
						</md-list-item> -->

						
				
			</div>
		</div>

	</md-toolbar>
</template>

<script>
	export default {
		data() {
			return {
				printer: false,
				interval: null
			}
		},
		created() {
			// this.getPrinter();
		},
		beforeDestroy() {
			// clearInterval(this.interval);
		},
		methods: {
			// getPrinter() {
			// 	var self = this;
			// 	this.interval = setInterval(() => {

			// 		this.$http.get("https://localhost:8084/test").then(data => {
			// 			self.printer = true;
			// 		})
			// 	}, 5000)
			// },
			toggleSidebar() {
				this.$sidebar.showSidebar = !this.$sidebar.showSidebar
			},
			logout() {
				this.$store.state.authentication.loggedIn = false;
				this.$store.state.authentication.authToken = null;
				this.$store.state.authentication.mode = "normal";
				this.$cookie.set('mode', "normal", 10);
				this.$cookie.delete('scanner_admin');
			},
			driverMode() {
				this.$store.state.authentication.mode = "driver";
				this.$cookie.set('mode', "driver", 10);
				window.location.reload();
			},
			scannerMode() {
				this.$store.state.authentication.mode = "scanner";
				this.$cookie.set('mode', "scanner", 10);
				window.location.reload();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue